import { useEffect, useState } from "react";
import {
  AreaInfo,
  CardInfo,
  getAreaEntry,
  getCardInfo,
  getImage,
  getLayoutEntry,
  getVCard,
} from "../Utils/BackendInterface";
import juraLogoSvg from "../resources/img/Jura_Logo.svg";
import mailIcon from "../resources/img/mailIcon.png";
import mapIcon from "../resources/img/mapIcon.png";
import phoneIcon from "../resources/img/phoneIcon.png";
import worldIcon from "../resources/img/worldIcon.png";
import copy_icon from "../resources/img/copy_icon1.png";
import personIcon from "../resources/img/personIcon.png";

import { copyToClipboard, disclaimerBody, disclaimerTitle } from "../Utils/utils";
import { useTranslation } from "react-i18next";

const infoIcons = [mailIcon, phoneIcon, phoneIcon, mapIcon, worldIcon];

export const Card = (props: { nfcId?: string }) => {
  const [t, i18n] = useTranslation();
  const [cardInfo, setCardInfo] = useState<CardInfo | undefined>();
  const [imgLink, setImgLink] = useState<string>();
  const [img, setImg] = useState<Blob | undefined>();
  const [vcard, setVCard] = useState("");

  const [areaInfo, setAreaInfo] = useState<AreaInfo | undefined>();

  // helper states
  const [address, setAddress] = useState("");
  const [layoutWebsite, setLayoutWebsite] = useState("");
  const [infoBoxLink, setInfoBoxLink] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = props?.nfcId ?? queryParams.get("id") ?? "";
    if (id) {
      getCardInfo(id).then((res) => {
        if (res) {
          setCardInfo(res);
          createVcardFile(res).then((url) => {
            if (url) setVCard(url);
          });

          // getAreaEntry(res.idArea).then((areaInfo) => setAddress(areaInfo?.address ?? ""));
          getLayoutEntry(res.idLayout).then((layoutInfo) => {
            setAddress(layoutInfo?.address ?? "");
            if (layoutInfo?.website) {
              setLayoutWebsite(layoutInfo.website);
            }
          });

          getAreaEntry(res.idArea).then((areaInfo) => setAreaInfo(areaInfo));

          getImage(id, res.pictureExtension ?? "").then((res) => {
            if (res) {
              console.log("had res");
              setImg(res);
            }
          });
        }
      });
    }
  }, []);

  /**
   * programmatically click the link when the link gets updated
   */
  useEffect(() => {
    if (infoBoxLink) {
      document.getElementById("infoBoxClicker")?.click();
    }
  }, [infoBoxLink]);

  const createVcardFile = async (cardInfo: CardInfo | undefined) => {
    if (!cardInfo) {
      return;
    }

    const vcard = await getVCard(cardInfo.nfcId);

    const objectURL = window.URL.createObjectURL(vcard);
    // window.open(objectURL);
    return objectURL;
  };

  const customStringFormat = (inString: string): string => {
    return inString.replaceAll(",", "\n");
  };

  const handleClickedInfoBox = (infoKey: string) => {
    switch (infoKey) {
      case "email":
        setInfoBoxLink(`mailto:${cardInfo?.email}`);
        break;
      case "telephone":
        setInfoBoxLink(`tel:${cardInfo?.telephone}`);
        break;
      case "mobile":
        setInfoBoxLink(`tel:${cardInfo?.mobile}`);
        break;
      case "address":
        window.open(
          `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
        );
        break;
      case "website":
        let url =
          layoutWebsite !== undefined && layoutWebsite !== "" ? layoutWebsite : cardInfo?.website;
        if (!url?.includes("http")) {
          url = `https://${url}`;
        }
        window.open(url);
        break;

      default:
        console.warn("invalid infobox clicked!");
        return;
    }
  };

  return (
    <div className="w-full h-full flex flex-col justify-start items-center">
      {/* Jura logo */}
      <div className="w-cardEntryWidth flex flex-row justify-end">
        <img src={juraLogoSvg} className="mt-7 h-card-logo" />
      </div>

      {/* image, name and title row */}
      <div className="w-cardEntryWidth flex flex-row justify-start items-center gap-6 mt-9 mb-6 max-w-lg">
        <div className="h-card-image max-w-card-image">
          {/* <img src={imgLink} className="h-full object-cover" /> */}
          <img src={img ? URL.createObjectURL(img) : ""} className="h-full object-cover" />
        </div>

        <div className="flex flex-col items-start">
          <div className="text-jura-gold-text text-xl leading-6">
            <span className="block m-0 h-fit">{cardInfo?.firstName}</span>
            <span className="block m-0 h-fit">{cardInfo?.surname}</span>
          </div>

          <span className="block mt-3 font-bold">{cardInfo?.jobDescription}</span>
        </div>
      </div>

      {/* info section  */}
      <div className="w-full h-fit bg-jura-light-grey-bg flex flex-col justify-center items-center pt-6 pb-6">
        <div className="flex flex-col w-cardEntryWidth items-center gap-5 mb-9 max-w-lg">
          {/* the actual info entry row */}
          {["email", "telephone", "mobile", "address", "website"].map((e, i) => {
            console.log("test", e, (cardInfo as any)?.[e]);
            if (!((cardInfo as any)?.[e] || (e === "address" && address))) {
              console.log("skipping", e);
              return "";
            }

            if (e === "website" && layoutWebsite && cardInfo) {
              cardInfo.website = layoutWebsite; // overwrite the card's website if the layout has its own for here (?)
            }

            return (
              <div
                key={`info_row_${e}`}
                className="w-full flex-col bg-white relative"
                id={`info_row_${e}`}
              >
                {/* <div className="w-full flex flex-row justify-end ">
                  <img
                    className="w-10 mr-1 mt-1 cursor-pointer"
                    src={copy_icon}
                    onClick={(event) => {
                      copyToClipboard(
                        e === "address" ? customStringFormat(address) : (cardInfo as any)?.[e] ?? ""
                      );
                      event?.stopPropagation();
                    }}
                  />
                </div> */}
                <img
                  className="absolute right-0 z-1 w-8 mr-1 mt-1 cursor-pointer active:bg-jura-light-grey-bg"
                  src={copy_icon}
                  onClick={(event) => {
                    copyToClipboard(
                      e === "address" ? customStringFormat(address) : (cardInfo as any)?.[e] ?? ""
                    );
                    event?.stopPropagation();
                  }}
                />
                <div className="w-full flex flex-row gap-6 justify-start items-center mb-6 mt-6">
                  <div
                    className="cursor-pointer ml-6 active:bg-jura-light-grey-bg select-none"
                    onClick={() => {
                      handleClickedInfoBox(e);
                    }}
                  >
                    <img src={infoIcons[i]} className="w-10  pointer-events-none" />
                  </div>

                  <div
                    className="flex flex-col items-start"
                    onClick={() => {
                      handleClickedInfoBox(e);
                    }}
                  >
                    <span className="block text-jura-gold-text text-lg">{t(e)}</span>
                    <div className="block text-black font-semibold max-w-full whitespace-pre-line break-all break-words mr-5">
                      {e === "address"
                        ? customStringFormat(address)
                        : customStringFormat((cardInfo as any)?.[e] ?? "")}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* the download vcf button */}
        {vcard && (
          <a
            href={vcard}
            download={`${cardInfo?.firstName ?? "card"}_${cardInfo?.surname ?? ""}`}
            className="flex flex-row min-w-download-vcf bg-white justify-center items-center p-4 mb-4 gap-4 cursor-pointer"
          >
            <img src={personIcon} className="w-8" />
            <span className="font-bold">{t("save-contact")}</span>
          </a>
        )}
      </div>

      <div className="w-cardEntryWidth mt-8 pb-4 text-sm text-center">
        <div className="font-semibold">{areaInfo?.disclaimerTitle}</div>
        <div className="whitespace-pre-line ">{areaInfo?.disclaimerText}</div>
      </div>

      <a className="hidden" id="infoBoxClicker" href={infoBoxLink} />
    </div>
  );
};
